import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { TrafficLightState} from './../../components/traffic-light/traffic-light'
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/interval';
import 'rxjs/add/operator/map';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  public trafficLightState: TrafficLightState;
  private trafficLightState$: Observable<number>;

  constructor(public navCtrl: NavController) {
    this.trafficLightState = TrafficLightState.red;
    this.trafficLightState$ = Observable.interval(1500)
        .map(i => Math.floor(Math.random() * 4));
  }

  ionViewWillEnter(){
    this.trafficLightState$.subscribe(state => this.trafficLightState = state);
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts